import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const emojiSets = [
  { emojis: ['🍎', '🥕', '🍍', '🍅', '🥭'], names: ['apple', 'carrot', 'pineapple', 'tomato', 'mango'] },
  { emojis: ['🍪', '🢁', '🍩', '🍫', '🍰'], names: ['cookie', 'cupcake', 'donut', 'chocolate', 'cake'] },
  { emojis: ['✏️', '🖊️', '🖍️', '📏', '🕐'], names: ['pencil', 'pen', 'crayon', 'ruler', 'triangle'] },
];

const FixRatioChartGame = () => {
  const [currentSet, setCurrentSet] = useState(0);
  const [itemCounts, setItemCounts] = useState({});
  const [gridItems, setGridItems] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState('');

  useEffect(() => {
    generateGrid();
  }, [currentSet]);

  const generateGrid = () => {
    const { emojis, names } = emojiSets[currentSet];
    let counts = {};
    const items = [];

    for (let i = 0; i < 25; i++) {
      const index = Math.floor(Math.random() * emojis.length);
      const emoji = emojis[index];
      const name = names[index];
      counts[name] = (counts[name] || 0) + 1;
      items.push({ emoji, name });
    }

    const tempAnswers = [];
    for (let i = 0; i < names.length - 1; i++) {
      const a = names[i];
      const b = names[i + 1];
      if (!counts[a] || !counts[b]) continue;
      tempAnswers.push({ label: `${a} to ${b}`, value: `${counts[a]} to ${counts[b]}`, correct: `${counts[a]}:${counts[b]}`, user: '', isCorrect: null });
    }

    setItemCounts(counts);
    setGridItems(items);
    setAnswers(tempAnswers);
    setResult('');
  };

  const handleChange = (index, value) => {
    const updated = [...answers];
    updated[index].user = value;
    setAnswers(updated);
  };

  const checkAnswers = () => {
    let correct = 0;
    const updated = answers.map(a => {
      const isCorrect = a.user.trim() === a.correct;
      if (isCorrect) correct++;
      return { ...a, isCorrect };
    });
    setAnswers(updated);
    setResult(`You got ${correct} out of ${answers.length} correct!`);
    if (correct==answers.length){
       const responsedata = ConstructorEventUpdateSQLStatus();
                      console.log("Event completed", responsedata);
    }
  };

  const nextSet = () => {
    setCurrentSet((currentSet + 1) % emojiSets.length);
  };

  const styles = {
    body: {
      fontFamily: 'Comic Sans MS, cursive',
      background: '#fff8e1',
      margin: 0,
      padding: 0,
      textAlign: 'center',
    },
    header: {
      backgroundColor: '#ffa000',
      color: 'white',
      padding: '20px',
      fontSize: '28px',
    },
    container: {
      padding: '30px',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 60px)',
      justifyContent: 'center',
      gap: '15px',
      marginBottom: '30px',
    },
    item: {
      width: '60px',
      height: '60px',
      fontSize: '32px',
    },
    table: {
      margin: '0 auto',
      borderCollapse: 'collapse',
      background: '#fff3e0',
      border: '2px solid #ffcc80',
    },
    thtd: {
      border: '1px solid #ffcc80',
      padding: '10px',
      fontSize: '16px',
    },
    input: {
      padding: '5px',
      fontSize: '14px',
      width: '70px',
      textAlign: 'center',
      border: '2px solid #ccc',
      borderRadius: '5px',
    },
    button: {
      marginTop: '20px',
      padding: '10px 20px',
      backgroundColor: '#ffa000',
      color: 'white',
      fontSize: '16px',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      marginRight: '10px'
    },
    result: {
      marginTop: '20px',
      fontSize: '18px',
      fontWeight: 'bold',
    },
    emoji: {
      fontSize: '20px'
    }
  };

  return (
    <div style={styles.body}>
      <header style={styles.header}>🧩 Fix the Ratio Chart!</header>
      <div style={styles.container}>
        <div style={styles.grid}>
          {gridItems.map((item, idx) => (
            <div key={idx} style={styles.item}>{item.emoji}</div>
          ))}
        </div>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.thtd}>Ratio of</th>
              <th style={styles.thtd}>Words</th>
              <th style={styles.thtd}>Your Answer</th>
              <th style={styles.thtd}>Result</th>
            </tr>
          </thead>
          <tbody>
            {answers.map((a, idx) => (
              <tr key={idx}>
                <td style={styles.thtd}>{a.label}</td>
                <td style={styles.thtd}>{a.value}</td>
                <td style={styles.thtd}>
                  <input
                    type="text"
                    value={a.user}
                    onChange={e => handleChange(idx, e.target.value)}
                    style={{ ...styles.input, borderColor: a.isCorrect == null ? '#ccc' : (a.isCorrect ? 'green' : 'red') }}
                  />
                </td>
                <td style={styles.thtd}>
                  <span style={styles.emoji}>{a.isCorrect == null ? '' : a.isCorrect ? '😃' : '😞'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div>
          <button style={styles.button} onClick={checkAnswers}>Check Answers ✅</button>
          <button style={styles.button} onClick={nextSet}>Next 🔄</button>
        </div>

        <div style={styles.result}>{result}</div>
      </div>
    </div>
  );
};

export default FixRatioChartGame;
